<template>
  <div class="registration-page">
    <div class="intro-page-container">
      <div class="main-copy-area background">
        <h2 class="blind">온라인 가입신청서 작성 초기화면</h2>
        <p class="flex">
          <span class="lg-u-plus">LG U<sup>+</sup></span
          ><span class="title">공식 온라인 가입채널에</span>
        </p>
        <p class="welcome-message">오신것을 환영합니다.</p>

        <div class="separator-small" />

        <div class="column-layout intro-copy">
          <p>
            <strong
              >실명확인 후 고객님께서 작성하신 가입신청서의 진행상황을 조회하실
              수 있습니다.</strong
            >
            <br />
            <em class="primary-text"
              >단, 신청완료일을 기준으로 14일이 경과된 가입신청서는 삭제되어
              조회하실 수 없습니다.</em
            >
          </p>
        </div>

        <div class="separator-small" />
      </div>
    </div>
    <div class="registration-page-container">
      <div class="section mt0">
        <div class="section-header">
          <h3>실명확인</h3>
        </div>
        <div class="section-body for-input">
          <dl class="field-group">
            <dt class="field-label">
              <label for="txtName"
                >이름<span class="additional-text"> (Name)</span></label
              >
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <input
                  ref="ref_name"
                  v-model="customer.name"
                  id="txtName"
                  type="text"
                  @input="onlyText"
                  name="name"
                  autocomplete="off"
                  class="input-width-medium input-text input-font"
                  title="성명입력"
                />
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="ssn1"
                >주민등록번호 혹은 외국인등록번호<br /><span
                  class="additional-text"
                  >(Alien Registration Number)</span
                ></label
              >
            </dt>
            <dd class="field-control">
              <div class="m-input-three">
                <input
                  v-model="customer.ssn1"
                  type="text"
                  ref="ref_ssn1"
                  id="ssn1"
                  name="ssn1"
                  @input="onlyNumber"
                  class="input-text input-width-xsmall input-font"
                  autocomplete="off"
                  maxlength="6"
                  title="주민등록번호 앞 여섯자리 입력"
                />
                <span class="field-group-space">-</span>
                <input
                  v-model="customer.ssn2"
                  type="password"
                  ref="ref_ssn2"
                  id="ssn2"
                  name="ssn2"
                  @input="onlyNumber"
                  class="input-text input-width-xsmall input-font"
                  autocomplete="new-password"
                  maxlength="7"
                  title="주민등록번호 뒤 일곱자리 입력"
                />
                <span class="field-group-space"></span>
                <!-- <button type='submit' @click='getRegistrationList' class='input-width-xsmall p0'>실명확인</button> -->
                <button
                  type="submit"
                  @click="verifyCustomerIdentification"
                  class="input-width-xsmall p0"
                >
                  실명확인
                </button>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label"></dt>
            <dd class="field-control">
              <ul>
                <li class='accordion type-01'>
                  <div  id="accordion-required-requiredForPersonalInformation" class='accordion-title'  role='heading'>
                <div id="checkbox-container-requiredForPersonalInformation" class='input-container'>
                  <input id="accordion-checkbox-requiredForPersonalInformation"
                    type='checkbox'
                    name='personalInformation'
                    class='input-checkbox input-text'
                  v-model='termConditionCheckedStatus'>
                  <label class='input-label' for="accordion-checkbox-requiredForPersonalInformation" >개인정보 수집 이용동의 (필수)</label>
                </div>
                <button class='fold-button'
                  @click='showHideAccordion()'
                  title='자세히보기' tabindex='0' 
                  area-controls="'accordion-requiredForPersonalInformation-detail'" 
                  id="requiredForPersonalInformation-show"
                ></button>                      
              </div>
              <div id="accordion-requiredForPersonalInformation-detail" class='accordion-detail' tabindex='0' aria-labelledby="requiredForPersonalInformation-show" role='region' >
                <p v-html="requiredForPersonalInformation" />
              </div>
                </li>
              </ul>
            </dd>
          </dl>

          <!---          
          <dl class='field-group'>
            <dt class='field-label'>
              <label for='id-verification-phonenumber'>휴대폰번호</label>
            </dt>
            <dd class='field-control'>
              <div class="field-control-sub sub-form m-input-half">  
                <input id='id-verification-phonenumber' type="number" autocomplete='off' name="hpNo" placeholder="'-' 없이 입력하세요" class='input-text input-width-medium input-font' title='본인인증할 휴대폰 번호 입력'>
                <button class='input-width-xsmall p0' type='button'>인증번호 발송</button>
              </div>
            </dd>
          </dl>
          <dl class='field-group'>
            <dt class='field-label'>
              <label for='id-verification-receieved-code-number'>인증번호입력</label>
            </dt>              
            <dd class='field-control'>
                <div class="field-control-sub sub-form m-input-half ml0">
                  <input id='id-verification-receieved-code-number' type="number" autocomplete='off'  name="" class='input-text input-width-medium input-font '>
                  <button type='submit' class='input-width-xsmall p0'>조회하기</button>
                </div>            
            </dd>   
          </dl>    
-->
        </div>

        <ul class="notice-text-list">
          <li class="notice-text">
            실명인증을 위해 가입자 본인 성명 및 주민등록번호를 입력하시고
            실명인증 버튼을 눌러주시기 바랍니다.
          </li>
          <li class="notice-text">
            타인의 정보 및 주민등록번호를 도용하는 경우 3년이하의 징역 또는
            1천만원 이하의 벌금에 처해지게 됩니다.
          </li>
          <li class="notice-text">
            가입자가 청소년일 경우 청소년 본인의 실명을 확인해 주시기 바랍니다.
          </li>
          <li class="notice-text">
            가입자가 외국인일 경우 본인의 이름과 외국인등록번호를 입력해 주시기
            바랍니다.
          </li>
        </ul>
      </div>

      <!-- <div class='section' v-if="registrationList.length > 0"> 
        <div class='section-header'>신청서 목록</div>
        <div class='section-body'>
          <ul class="notice-text-list">
            <li class='notice-text'>'신청서 바로가기'를 클릭하시면 고객님께서 작성하신 가입신청내역을 확인 및 수정 할 수 있습니다.<br>
              <em class='primary-text'>단, 개통대기 이후에 수정을 원하시는 경우 먼저 신청대리점으로 문의하시기 바랍니다.</em>
            </li>
          </ul> -->

      <!---  
          <div class='data-grid-area'>
            <table class='section-grid data-grid' summary='작성한 신청서 목록'>
              <caption>작성한 신청서 목록</caption>
              <thead>
                <tr>
                  <th scope='col' rowspan='2'>신청번호</th>
                  <th scope='col'>신청대리점</th>
                  <th scope='col'>구매쇼핑몰</th>
                  <th scope='col'>가입유형</th>
                  <th scope='col'>작성완료일</th>
                  <th scope='col'>진행사항</th>
                  <th scope='col'>신청단말기</th>
                  <th scope='col'>신청요금제</th>
                </tr>
                <tr>
                  <th scope='col' colspan="4">위치</th>
                  <th scope='col'>연락처</th>
                  <th scope='col' colspan="2">이메일</th>
                </tr>
              </thead>
              <tbody v-for='registration in registrationList' v-bind:key='registration.appfNo'>
                <tr>
                  <td rowspan='2' class='clickable primary-text' @click="getRegistration(registration.appfNo)">{{registration.onlnAppfNo}}</td>
                  <td>{{registration.dealNm}}</td>
                  <td>{{registration.opmkNm}}</td>
                  <td>{{registration.entrKdCd}}</td>
                  <td>{{registration.entrAppfChgDttm}}</td>
                  <td>{{registration.rqstPgrsStusCd}}</td>
                  <td>{{registration.dvicMdlNm}}</td>
                  <td>{{registration.dataPpNm}}</td>
                </tr>
                <tr>
                  <td colspan="4">{{registration.dlplBadr}} {{registration.dlplDadr}}</td>
                  <td>{{registration.aplcTlno}}</td>
                  <td colspan="2">{{registration.aplcEmalAddr}}</td>
                </tr>
              </tbody>
            </table>
          </div>  -->

      <!-- <div class='responsive-list'>
            <ul v-if="registrationList.length > 0">
              <li v-for='registration in registrationList' v-bind:key='registration.appfNo' tabindex='0'>
                <div class='responsive-list-col'>
                  <div class='responsive-list-row'>     
                    <span class='m-row m-row-top'>                   
                      <dl class='list-text-big'>
                        <dt class='blind'>신청단말</dt>
                        <dd>
                          <strong v-if='registration.trmMdlNm'>{{registration.trmMdlNm}}</strong>
                          <strong v-if='!registration.trmMdlNm'>단말 미선택</strong>
                        </dd>
                      </dl>
                    </span>  
                    <span class='m-row'>        
                      <dl class='list-text-medium'>
                        <dt class='blind'>가입유형 및 요금제</dt>
                        <dd>
                          ({{registration.onetKdNm}})
                          <span class='ml5' v-if='registration.ppNm'>{{registration.ppNm}}</span>
                          <span class='ml5' v-if='registration.dataPpNm'>{{registration.dataPpNm}}</span>
                          <span class='ml5' v-if='!registration.ppNm && !registration.dataPpNm'>요금제 미선택</span>
                        </dd>                      
                      </dl>                                  
                    </span>            
                    <a class='link-detail pc-float-right' @click="getRegistration(registration.appfNo, registration.sbgnDealCd, registration.onetAppfFomNo, registration.opmkNo)" title='화면전환' target='_self' tabindex='0'>신청서 바로가기</a>                                             

                  </div>      

                  <div class='responsive-list-row'>
                    <span class='m-row'>
                     <dl class='list-text-small'>
                        <dt class='blind'>진행상태</dt>
                        <dd  class='primary-text'>
                          <strong>{{registration.rqstPgrsStusNm}}</strong>
                        </dd>
                      </dl>                    
                      <dl class='list-text-small'>
                        <dt>신청번호</dt>
                        <dd>
                            <strong>{{registration.onlnAppfNo}}</strong>
                        </dd>
                      </dl>
                      <dl class='list-text-small'>               
                        <dt class='m-blind'>작성일</dt>
                        <dd>{{registration.onetAppfMakDttm}}</dd>
                      </dl>                      
                    </span>
                  </div>
                  <div class='responsive-list-row sub-text'>                         
                    <dl class='list-text-small'>
                      <dt class='blind'>신청대리점</dt><dd>{{registration.dealNm}}</dd>
                    </dl>
                    <dl class='list-text-small'>
                      <dt class='blind'>구매쇼핑몰</dt><dd>{{registration.sbrnNm}}</dd>
                    </dl>                  
                    <dl class='list-text-small'>  
                      <dt class='blind'>위치</dt><dd>{{registration.sbrnAddr}}</dd>
                    </dl>
                    <dl class='list-text-small'>
                      <dt class='blind'>연락처</dt><dd>{{registration.sbrnTlno}}</dd>
                    </dl>
                    <dl class='list-text-small'>
                      <dt class='blind'>이메일</dt><dd>{{registration.sbrnEmalAddr}}</dd>
                    </dl>                                           
                  </div>                                      
                </div>
              </li>
            </ul>
          </div>

        </div>
      </div> -->
    </div>
    <v-dialog />
  </div>
</template>

<script>
import { getRegistrationList, getRegistration } from '@/api/captureService'
import { verify } from '@/api/ucube'

import { actionType } from '@/store'
import { router } from '@/router/router'

export default {
  name: 'ExistingRegistration',

  data() {
    return {
      registrationList: [],
      verifyResult: {},
      customer: {
        name: '',
        ssn1: '',
        ssn2: ''
      },
      termConditionCheckedStatus: false,
      personalInformation: ''
    }
  },

  components: {},

  mounted() {
    let params = this.getUrlParams()
    if (params.accessType !== 'E') {
      router.replace({
        name: 'Error',
        props: true,
        params: {
          message:
            '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n신청서 작성시 기입 하신 이메일로 발송 된 경로를 통하여 다시 접속하여 주세요.',
          type: 'access'
        }
      })
    }
  },
  computed: {
    requiredForPersonalInformation() {
      let fileName = 'agree2.html'
      //if (this.isNote7) fileName = 'agree2_SM_N930L.html'
      return require('html-loader!~/html/appl/' + fileName)
    }
  },

  methods: {
    /** 
     * Function    : getUrlParams
     * Description : Url 파라미터 값 지역변수로 설정 (임시저장에서 이메일로 들어온 경우)
     **/
    getUrlParams() {
      var params = {}
      window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
        str,
        key,
        value
      ) {
        params[key] = value
      })
      return params
    },

    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      if(e.target.name === 'ssn1') this.customer.ssn1 = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'ssn2') this.customer.ssn2 = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      if(e.target.name === 'name') this.customer.name = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },

    /** 
     * Function    : getRegistrationList
     * Description : 진행중인 신청서 리스트 조회
     **/
    // getRegistrationList() {
    //   let params = this.getUrlParams()
    //   let title = '온라인 가입신청 안내'
    //   let message = ''
    //   let accessType = 'E'
    //   let appfNo = ''
    //   if (params.accessType) {
    //     accessType = params.accessType
    //     appfNo = params.appfNo
    //   }
    //   let info = {
    //     accessType: accessType,
    //     appfNo: appfNo
    //   }
    //   this.$store.dispatch(actionType.saveApplicationNumber, appfNo)

    //   if (this.validateCustomerIdentificationInput()) {
    //     verify(
    //       this.customer.name,
    //       this.customer.ssn1,
    //       this.customer.ssn2,
    //       info
    //     ).then(res => {
    //       this.verifyResult = res.data.dsRes
    //       message = this.verifyResult.msg
    //       this.$store.state.step1.customer.name = this.customer.name
    //       this.$store.state.step1.customer.ssn1 = this.customer.ssn1
    //       this.$store.state.step1.customer.ssn2 = this.customer.ssn2
    //       if (res.data.dsRes.msgCd === 'S' || res.data.dsRes.msgCd === 'E') {
    //         getRegistrationList(
    //           this.customer.name,
    //           this.customer.ssn1,
    //           this.customer.ssn2
    //         ).then(res => {
    //           this.registrationList = res.data
    //           if (this.registrationList.length < 1) {
    //             message = '작성된 신청서가 없습니다.'
    //             this.openAlert(title, message)
    //           }
    //         })
    //       } else {
    //         this.openAlert(title, message)
    //         this.registrationList = []
    //       }
    //     })
    //   }
    // },

    /** 
     * Function    : verifyCustomerIdentification
     * Description : 실명인증 -> Step4로 이동
     **/
    verifyCustomerIdentification() {
      let params = this.getUrlParams()
      let title = '온라인 가입신청 안내'
      let message = ''
      let accessType = 'E'
      let crypAppfNo = ''

      if(!this.termConditionCheckedStatus){
        message = "개인정보 수집 이용 동의에 동의하셔야 합니다."
        this.openAlert(title, message)
        return false;
      }

      // 이메일 접속 시 parameter 값들
      // appfNo는 암호화된 값
      if (params.accessType) {
        accessType = params.accessType
        crypAppfNo = params.appfNo
      }
      let info = {
        accessType: accessType,
        appfNo: crypAppfNo
      }

      if (this.validateCustomerIdentificationInput()) {
        verify(
          this.customer.name,
          this.customer.ssn1,
          this.customer.ssn2,
          info
        ).then(res => {
          let response = res.data
          this.$store.state.step1.customer.name = this.customer.name
          this.$store.state.step1.customer.ssn1 = this.customer.ssn1
          this.$store.state.step1.customer.ssn2 = this.customer.ssn2
          message = response.dsRes.msg
          if (response.dsRes.msgCd === 'S' || response.dsRes.msgCd === 'E') {
            if (response.dsRes.msgCd === 'E') {
              this.$store.dispatch(
                actionType.saveApplicationNumber,
                response.resultData.crypAppfNo
              )

              this.$modal.hide('dialog')
              if (
                response.resultData.rqstPgrsStusCd === '40' ||
                response.resultData.rqstPgrsStusCd === '30' ||
                response.resultData.rqstPgrsStusCd === '20'
              ) {
                this.$router.push({
                  name: 'RegistrationStep4'
                })
              } else {
                this.openAlert(title, '유효하지 않은 신청서입니다.')
              }
            } else {
              this.$store.dispatch(actionType.saveApplicationNumber, '')
            }
          }
          this.openAlert(title, message)
        })
      }
    },

    /** 
     * Function    : getRegistration
     * Description : 신청서 상세 조회
     **/
    // getRegistration(appfNo, sbgnDealCd, entrRqstFomNo, opmkNo) {
    //   let applicationNumber = appfNo
    //   this.$store.dispatch(actionType.saveApplicationNumber, appfNo)

    //   if (applicationNumber) {
    //     getRegistration(applicationNumber, "E").then(res => {
    //       let registration = res.data.opmktRegistrationCapture
    //       if (
    //         registration.rqstPgrsStusCd === '40' ||
    //         registration.rqstPgrsStusCd === '30' ||
    //         registration.rqstPgrsStusCd === '20'
    //       ) {
    //         this.$router.push({
    //           name: 'RegistrationStep4'
    //         })
    //       } else {
    //         this.$router.push({
    //           name: 'RegistrationStep2'
    //         })
    //       }
    //     })
    //   }
    // },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              if (ref) {
                ref.focus()
              }
            }
          }
        ]
      })
    },

    /** 
     * Function    : validateCustomerIdentificationInput
     * Description : 필수값 Validation
     **/
    validateCustomerIdentificationInput() {
      let title = '온라인 가입신청 안내'
      let message = ''

      if (this.customer.name === '') {
        message = '이름을 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_name)
        return false
      }
      let regExpNm = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|\s]+$/
      if (!regExpNm.test(this.customer.name)) {
        message = '이름은 한글, 영어, 숫자만 입력 가능합니다.'
        this.openAlert(title, message, this.$refs.ref_name)
        return false
      }
      if (this.customer.ssn1 === '') {
        message = '주민번호 앞자리를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn1)
        return false
      }
      let regExpSsn1 = /^[0-9]{6}$/
      if (!regExpSsn1.test(this.customer.ssn1)) {
        message = '주민번호 앞자리는 6자리 숫자를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn1)
        return false
      }
      if (this.customer.ssn2 === '') {
        message = '주민번호 뒷자리를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn2)
        return false
      }
      let regExpSsn2 = /^[0-9]{7}$/
      if (!regExpSsn2.test(this.customer.ssn2)) {
        message = '주민번호 뒷자리는 7자리 숫자를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_ssn2)
        return false
      }
      return true
    },
    /** 
       * Function    : showHideAccordion
       * Description : 약관 Accordion Control
       **/
      showHideAccordion() {
        const panel = document.getElementById('accordion-requiredForPersonalInformation-detail')
        
        if (panel.style.maxHeight)
          panel.style.maxHeight = null,
          panel.style.height = null,
          panel.style.padding = '0 12px',
          panel.style.overflow = 'hidden',
          panel.style.visibility = 'hidden',
          panel.previousElementSibling.classList.toggle("active");
        else
          panel.style.maxHeight = '220px',
          panel.style.height = 'auto',
          panel.style.padding = '12px',
          panel.style.overflow = 'auto',
          panel.style.visibility = 'visible',
          panel.previousElementSibling.classList.toggle("active");
      }
  }
}
</script>

<style scoped>
.ml5 {
  margin-left: 5px;
}
</style>
